import { Component, OnInit } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-password-cell',
  templateUrl: './password-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class PasswordCellComponent extends InlineEditCellDirective implements OnInit {
  ngOnInit(): void {}

  onKeyupEnter() {
    if (!this.mandatory || this.rowData[this.fieldName]) {
      this.isEdited = false
      this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    }
  }

  triggerEdit() {
    setTimeout(() => {
      this.originalContent = this.rowData[this.fieldName]
      this.isEdited = true
    }, 0)
  }
}
